var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.key_id}},[_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_vm._v(_vm._s(_vm.name))]),_c('b-col',{attrs:{"cols":"4"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }